import { render, staticRenderFns } from "./propmoduleconfig.vue?vue&type=template&id=00597baa"
import script from "./propmoduleconfig.vue?vue&type=script&lang=js"
export * from "./propmoduleconfig.vue?vue&type=script&lang=js"
import style0 from "./propmoduleconfig.vue?vue&type=style&index=0&id=00597baa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports